module.exports = __webpack_public_path__ + "img/dianxin3-1.983de463.png";